module.exports = __webpack_public_path__ + "static/media/marvelous_04.eeac4bdd.jpg";